/**
 * Mount Rigi shop page - add to cart straight from a card.
 *
 * Only single-variant products get a form; products with options link to their
 * product page instead. Each form is a real <form> posting to /cart/add, so it
 * works without JavaScript and lands on the cart page. With JavaScript it adds
 * over fetch and hands the response to the cart drawer, which re-renders and
 * opens.
 */
(() => {
  'use strict';

  const openCartDrawer = (state) => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(state);
      return true;
    }
    return false;
  };

  const bindForm = (form) => {
    if (form.dataset.mrShopReady === 'true') return;
    form.dataset.mrShopReady = 'true';

    const submit = form.querySelector('[data-mr-shop-submit]');
    const status = form.parentElement.querySelector('[data-mr-shop-status]');

    const setStatus = (message, state) => {
      if (!status) return;
      status.textContent = message || '';
      if (state) {
        status.dataset.state = state;
      } else {
        delete status.dataset.state;
      }
    };

    form.addEventListener('submit', async (event) => {
      if (!window.fetch) return;
      event.preventDefault();
      if (submit?.getAttribute('aria-busy') === 'true') return;

      const body = new FormData(form);
      body.append('sections', 'cart-drawer,cart-icon-bubble');
      body.append('sections_url', window.location.pathname);

      submit?.setAttribute('aria-busy', 'true');
      setStatus('');

      try {
        const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body,
        });
        const state = await response.json();

        if (!response.ok) {
          setStatus(state?.description || state?.message || 'This item could not be added.', 'error');
          return;
        }

        if (!openCartDrawer(state)) window.location.assign(window.routes?.cart_url || '/cart');
      } catch (_) {
        form.submit();
      } finally {
        submit?.removeAttribute('aria-busy');
      }
    });
  };

  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-mr-shop-form]').forEach(bindForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
